import React, { Fragment, useMemo } from 'react';

import { JRCAlbumItemProps } from '../types';
import { AlbumX2 } from './AlbumX2';
import { ALBUM_DEFAULT_MAX_WIDTH } from '../const';

export const AlbumX4 = ({ files, maxWidth = ALBUM_DEFAULT_MAX_WIDTH, onClick }: JRCAlbumItemProps) => {
    const { filesX2Top, filesX2Bottom } = useMemo(() => {
        return {
            filesX2Top: [...files].splice(0, 2),
            filesX2Bottom: [...files].splice(2, 4),
        };
    }, [files]);

    return (
        <Fragment>
            <AlbumX2 files={filesX2Top} maxWidth={maxWidth} onClick={onClick} />
            <AlbumX2 files={filesX2Bottom} maxWidth={maxWidth} onClick={onClick} />
        </Fragment>
    );
};
